import React, { useCallback, useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ItemContent, ItemTitle } from '../DarkWebStyles';
import { DataItem, DataItemText, DeleteIcon } from '../DarkWebModal/DarkWebModalStyles';
import { deleteCreditCard } from '../../../../ExperianActions';
import StopMonitoringModal from '../StopMonitoringModal/StopMonitoringModal';
import ExperianContext from '../../../../ExperianContext';

const CreditCards = ({ title, data }) => {
  const [cardToDelete, setCardToDelete] = useState(null);

  const { clientId, subscriberId } = useContext(ExperianContext);

  const dispatch = useDispatch();

  const onConfirmCallback = useCallback(async () => {
    await dispatch(deleteCreditCard(clientId, subscriberId, cardToDelete.CardLabel));
    setCardToDelete(null);
  }, [clientId, subscriberId, cardToDelete, dispatch]);

  return (
    data &&
    data.length > 0 && (
      <>
        <div>
          <ItemTitle>{title}</ItemTitle>
          <ItemContent>
            {data.map(card => (
              <DataItem key={card.CardNumber}>
                <DeleteIcon onClick={() => setCardToDelete(card)} />
                <DataItemText>{card.CardNumber}</DataItemText>
              </DataItem>
            ))}
          </ItemContent>
        </div>
        {!!cardToDelete && (
          <StopMonitoringModal
            onConfirm={onConfirmCallback}
            onRequestClose={() => setCardToDelete(null)}
          >
            Are you sure you want to stop monitoring:
            <br />
            Credit card {cardToDelete.CardNumber}?
          </StopMonitoringModal>
        )}
      </>
    )
  );
};

export default CreditCards;
